import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaSuitcase } from "react-icons/fa6";
import Leaves from "./index";
import ViewLeave from "./view";
import EditLeave from "./edit";
import { MODULE_LEAVE } from "variables/constants";

const leavesRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Leaves",
		basePath: "leaves",
		mainComponent: <Leaves />,
	    layout: "/console",	   
	    icon: <FaSuitcase className="icon-item" />,
	    subTitle:"Leave",
	    viewComponent: <ViewLeave />,
	    createComponent: <EditLeave />,
	    editComponent: <EditLeave />,
		level:5,
		moduleId: MODULE_LEAVE,
	})
]

export default leavesRoutes;